export default {
  // ========== Botones y acciones ==========
  evaluationsXlsx: 'EVALUACIONES XLSX',

  // ========== Encabezados de tabla ==========
  evaluations: 'Evaluaciones',
  colSubjectCode: 'Sigla Asignatura',
  colSubject: 'Asignatura',
  colPlanLevel: 'Nivel del Plan',
  colEvaluationType: 'Tipo de evaluación',
  colLearningOutcome: 'Resultado de aprendizaje',
  colAchievementIndicators: 'Indicadores de Logro',
  colEvaluativeSituation: 'Situación evaluativa',
  colEvaluationDescription: 'Descripción evaluación',
  colEvaluationDescriptionTooltip: 'Descripción evaluación (Mencionar las características principales que configuran la actividad de evaluación: características principales del encargo, ejecución práctica, pruebas escritas o presentación)',
  colEvaluativeAgent: 'Agente evaluativo',
  colEvaluationWeighting: 'Ponderación evaluación',
  colSituationWeighting: 'Ponderación por situación evaluativa',
  colDirectedTeachingHours: 'Horas de Docencia Dirigida (pedagógicas)',
  colAutonomousWorkHours: 'Horas de Trabajo Autónomo Preparación y/o Ejecución (cronológicas)',
  colWorkType: 'Tipo de trabajo',
  colEnvironment: 'Ambiente',
  colExaminer: 'Examinador/a',

  // ========== Mensajes ==========
  noDataToShow: 'No hay datos para mostrar',

  // ========== Breadcrumb ==========
  breadcrumbEvaluations: 'Evaluaciones',

  // ========== Descarga Excel ==========
  generatingExcel: 'Generando Excel...',
  pleaseWaitWhileGenerating: 'Por favor, espera mientras se genera el archivo.',
  downloadError: 'No se pudo descargar el archivo.',
  generationError: 'Hubo un problema al generar el archivo.',
}
